<template>
  <b-notification
    v-if="visible"
    type="is-info is-light"
    has-icon
    aria-close-label="Close notification"
    @close="visible = false"
  >
    <p>
      <strong>{{ $t('general.disclaimer.version') }}</strong>
    </p>
    <p>
      {{ $t('general.disclaimer.intro1')
      }}<span class="disclaimer-asterisk">*</span>{{
        $t('general.disclaimer.intro2')
      }}<b-icon icon="information-variant" type="is-info" size="is-small" />{{
        $t('general.disclaimer.intro3')
      }}<b-icon icon="format-section" type="is-warning" size="is-small" />{{
        $t('general.disclaimer.intro4')
      }}<b-icon icon="cog-outline" size="is-small" />{{ $t('general.disclaimer.intro5') }}
    </p>
    <p>
      {{ $t('general.disclaimer.actions') }}
    </p>
    <p>
      {{ $t('general.disclaimer.submit1') }}
      <a href="https://studien-fb16.imi-frankfurt.de/" target="_blank" rel="noopener">
        <b-icon icon="open-in-new" size="is-small" />
        Upload-Portal
      </a>
      {{ $t('general.disclaimer.submit2') }}
      <a
        href="https://roxtra.kgu.de/roxtra/doc/showfolder.aspx?folderid=55917"
        target="_blank"
        rel="noopener"
      >
        <b-icon icon="open-in-new" size="is-small" />
        roXtra-Ordner ID 55917
      </a>
      {{ $t('general.disclaimer.download1') }}
      <a
        href="/documents/Verpflichtungserklaerung-Datennutzung.docx"
        target="_blank"
        rel="noopener"
        download
      >
        <b-icon icon="file-document-outline" size="is-small" />
        {{ $t('general.disclaimer.downloadLink') }}
      </a>
      {{ $t('general.disclaimer.download2') }}
      {{ $t('general.disclaimer.submit3') }}
      <MailtoLink
        user="forschungfb16"
        domain="uni-frankfurt.de"
        subject="Anfrage zum digitalen Datenschutzkonzept"
      />
    </p>
    <p>
      {{ $t('general.disclaimer.feedback') }}
      <MailtoLink
        user="forfb16"
        domain="uni-frankfurt.de"
        subject="Feedback zum digitalen Datenschutzkonzept"
      />
    </p>
  </b-notification>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { BIcon, BNotification } from 'buefy'
import MailtoLink from '@/components/MailtoLink.vue'

const visible = ref(true)
</script>

<style scoped>
.disclaimer-asterisk {
  color: red;
}
</style>
